import { useRef as i, useEffect as a } from "react";

var f = ["mousedown", "touchstart"],
    g = function g(r, t) {
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var n = i(t),
      c = s.events || f;
  a(function () {
    n.current = t;
  }, [t]), a(function () {
    var o = function o(e) {
      var u = r.current,
          d = e.target;

      if (s.isExcludeTargets) {
        var l = document.querySelectorAll("[data-click-target-exclude]");
        if (Array.from(l).some(function (E) {
          return E.contains(d);
        })) return;
      }

      u && !u.contains(d) && n.current(e);
    };

    return c.forEach(function (e) {
      return document.addEventListener(e, o);
    }), function () {
      return c.forEach(function (e) {
        return document.removeEventListener(e, o);
      });
    };
  }, [c, r]);
};

export { g as useClickAway };